import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';

/** Query key factory. Every key starts with 'organizations' so invalidation is one call. */
export const organizationKeys = {
  all: ['organizations'] as const,
  lists: () => [...organizationKeys.all, 'list'] as const,
  list: (params: ListParams) => [...organizationKeys.lists(), params] as const,
  // Under lists() on purpose: a provision or status change invalidates it with the tables.
  summary: () => [...organizationKeys.lists(), 'summary'] as const,
  options: () => [...organizationKeys.lists(), 'options'] as const,
  details: () => [...organizationKeys.all, 'detail'] as const,
  detail: (organizationId: string) => [...organizationKeys.details(), organizationId] as const,
  usage: (organizationId: string) => [...organizationKeys.detail(organizationId), 'usage'] as const,
  exportJobs: (organizationId: string) =>
    [...organizationKeys.detail(organizationId), 'export'] as const,
  supportSessions: () => [...organizationKeys.all, 'support-sessions'] as const,
  supportSessionList: (filter: { organizationId?: string; active?: boolean }) =>
    [...organizationKeys.supportSessions(), filter] as const,
};
